// src/pages/VisualMap.js
import React from 'react';

function VisualMap() {
  return (
    <div>
      <h2>Visual Map</h2>
      <p>This page will display an interactive map of major breweries and microbreweries in Africa.</p>
    </div>
  );
}

export default VisualMap;
